import React from 'react';
import { motion } from 'framer-motion';
import JsonReprocessorNew from '../components/JsonReprocessorNew';

const ReprocessPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gray-50 py-6"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <JsonReprocessorNew />
      </div>
    </motion.div>
  );
};

export default ReprocessPage;
